/**
 * Citron search — recent searches.
 *
 * Horizon already owns predictive search itself (debouncing, arrow-key
 * navigation, Escape, ARIA), so this only adds what the theme lacks: a
 * per-device history of what the shopper searched for.
 */
(function () {
  'use strict';

  var KEY = 'citronRecentSearches';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private mode) — recent searches simply won't persist */
    }
  }

  function limitFor(block) {
    return parseInt(block.getAttribute('data-limit'), 10) || 6;
  }

  function remember(term) {
    term = (term || '').trim();
    if (!term) return;

    var list = read().filter(function (t) {
      return t.toLowerCase() !== term.toLowerCase();
    });
    list.unshift(term);
    write(list.slice(0, 10));
  }

  function searchUrl() {
    return window.Theme && Theme.routes && Theme.routes.search_url ? Theme.routes.search_url : '/search';
  }

  /** Paint the stored history into any empty-state block on the page. */
  function render() {
    var blocks = document.querySelectorAll('[data-ctr-recent]');
    if (!blocks.length) return;

    var list = read();

    Array.prototype.forEach.call(blocks, function (block) {
      var host = block.querySelector('[data-ctr-recent-list]');
      if (!host) return;

      var items = list.slice(0, limitFor(block));
      if (!items.length) {
        block.hidden = true;
        return;
      }

      host.textContent = '';
      items.forEach(function (term) {
        var a = document.createElement('a');
        a.className = 'ctr-search__chip';
        a.href = searchUrl() + '?q=' + encodeURIComponent(term);
        a.textContent = term;
        host.appendChild(a);
      });
      block.hidden = false;

      var clear = block.querySelector('[data-ctr-recent-clear]');
      if (clear && !clear.dataset.ctrBound) {
        clear.dataset.ctrBound = '1';
        clear.addEventListener('click', function () {
          write([]);
          block.hidden = true;
        });
      }
    });
  }

  // Capture searches from any search form on the page.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches('form[action*="/search"]')) return;

      var input = form.querySelector('input[name="q"]');
      if (input) remember(input.value);
    },
    true
  );

  // The overlay injects its empty state after opening, so re-render on change.
  function observe() {
    render();

    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () {
      render();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
